// src/components/login/SocialLogin.tsx
import React, {useContext} from 'react'
import styles from './css/SocialLogin.module.css'
import {FcGoogle} from 'react-icons/fc'
import {MicrosoftIcon} from './MicrosoftIcon'
import {IconBaseProps} from 'react-icons'
import {AuthContext, Provider} from '../../context/AuthContext'

export const SocialLogin: React.FC = () => {
    const {signInSocial} = useContext(AuthContext)

    // Cast icons to satisfy TS
    const GoogleIcon = FcGoogle as React.FC<IconBaseProps>

    return (
        <div className={styles.container}>
            <button
                className={styles.btn}
                onClick={() => signInSocial('GOOGLE' as Provider)}
            >
                <GoogleIcon className={styles.icon}/>
            </button>

            <button
                className={styles.btn}
                onClick={() => signInSocial('MICROSOFT' as Provider)}
            >
                <MicrosoftIcon className={styles.icon}/>
            </button>
        </div>
    )
}
